import { FunctionComponent } from 'react';
import { ButtonStyled } from './styled';
import { Button as BootstrapButton } from 'react-bootstrap';
import { ClipLoader } from 'react-spinners';

export enum ButtonVariant {
  primary = 'primary',
  secondary = 'secondary',
  success = 'success',
  warning = 'warning',
  danger = 'danger',
}

export interface ButtonProps {
  title?: string;
  variant?: keyof typeof ButtonVariant;
  onClick?: Function;
  disabled?: boolean;
  loading?: boolean;
}

const Button: FunctionComponent<ButtonProps> = ({
  title = '',
  variant = ButtonVariant.primary,
  onClick = () => {},
  disabled = false,
  loading = false,
}) => {
  return (
    <ButtonStyled>
      <BootstrapButton
        variant={variant}
        onClick={(event: React.MouseEvent<HTMLElement, MouseEvent>) => onClick(event)}
        disabled={disabled}
      >
        {loading ? <ClipLoader color="#fff" loading={loading} size={30} /> : <span>{title}</span>}
      </BootstrapButton>
    </ButtonStyled>
  );
};

export default Button;
